import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-primary-phone',
  templateUrl: './update-primary-phone.component.html',
  styleUrls: ['./update-primary-phone.component.css']
})
export class UpdatePrimaryPhoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
